import styles from './styles';

export interface SearchFilterSubHeaderProps {
  subTitle: string;
}

export default function SearchFilterSubHeader({
  subTitle,
}: SearchFilterSubHeaderProps): JSX.Element {
  return (
    <div className="filter-sub-header">
      <div data-testid="filter-sub-title" className="filter-sub-title">
        {subTitle}
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}
